export default __webpack_public_path__ + "059342f2af22f9af40045cdd5ef67ac8.png";